import React, { Component } from "react";
import Icon from "./Icon";
import Tooltip from "./Tooltip";

class NewImageButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHover: false
    };
  }

  renderButton() {
    const isHover = this.state.isHover;

    return (
      <div
        className="new-img-btn"
        style={{
          height: "34px",
          width: "34px",
          minWidth: "34px",
          minHeight: "34px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
          border: isHover ? "1px solid #9CA3AF" : "1px solid #ddd",
          borderRadius: "8px",
          cursor: "pointer",
          padding: "7px",
          transition: "border 0.2s ease"
        }}
        onClick={() => {
          if (this.props.onClick) {
            this.props.onClick();
          }
        }}
        onMouseEnter={() => this.setState({ isHover: true })}
        onMouseLeave={() => this.setState({ isHover: false })}
      >
        <Icon
          type={this.props.icon ? this.props.icon : this.props.type}
          style={{
            width: "16px",
            height: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0",
            padding: "0"
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <>
        {this.props.label ? (
          <Tooltip content={this.props.label} direction="top">
            {this.renderButton()}
          </Tooltip>
        ) : (
          this.renderButton()
        )}
      </>
    );
  }
}

export default NewImageButton;